import { KVGrid } from './components/ui';

/**
 * UserMetricsChart — the player's assessment profile (GET /api/users/:id): cognitive, MoCA, motor,
 * FULG and physiological baselines. These use different scales and units, so they are shown as
 * labelled values rather than bars on a shared axis; anything not recorded says so.
 *
 * userData: { name, cog_level, moca, motor_level, fulg, baselineHR, baselineGSR, colorblindness, ... }
 */
const FIELDS = [
    { key: 'cog_level', label: 'Cognitive level' },
    { key: 'moca', label: 'MoCA score' },
    { key: 'motor_level', label: 'Motor level' },
    { key: 'fulg', label: 'FULG' },
    { key: 'baselineHR', label: 'Baseline heart rate', unit: 'bpm' },
    { key: 'baselineGSR', label: 'Baseline GSR' },
    { key: 'colorblindness', label: 'Colour blindness' },
];

const present = (v) => v !== undefined && v !== null && v !== '' && !(typeof v === 'number' && !Number.isFinite(v));

function show(v, unit) {
    if (typeof v === 'boolean') return v ? 'Yes' : 'No';
    const n = typeof v === 'number' ? v : Number(v);
    if (typeof v !== 'object' && v !== '' && Number.isFinite(n)) return `${+n.toFixed(2)}${unit ? ` ${unit}` : ''}`;
    return typeof v === 'object' ? JSON.stringify(v) : String(v);
}

function UserMetricsChart({ userData }) {
    const data = userData && typeof userData === 'object' && !Array.isArray(userData) ? userData : null;
    const recorded = data ? FIELDS.filter((f) => present(data[f.key])) : [];

    if (!recorded.length) {
        return (
            <div style={{ padding: 24, background: 'var(--egdl-surface-sunken)', fontSize: 17, lineHeight: 1.5, color: 'var(--egdl-text-secondary)' }}>
                No assessment data
            </div>
        );
    }

    return (
        <KVGrid
            rows={FIELDS.map((f) => ({
                label: f.label,
                value: present(data[f.key])
                    ? show(data[f.key], f.unit)
                    : <span style={{ fontWeight: 400, color: 'var(--egdl-text-secondary)' }}>Not recorded</span>,
            }))}
        />
    );
}

export default UserMetricsChart;
